import { IGatsbyImageData } from 'gatsby-plugin-image'

import { ImageType, MarkdownListQueryType, PostItemType } from '~/types/post.types'

export function postListMapper(query: MarkdownListQueryType): Array<PostItemType> {
  return query.allMarkdownRemark.edges
}

export function postItemMapper(query: PostItemType) {
  return query.node
}

export function imageMapper(image: ImageType): IGatsbyImageData {
  return image.childImageSharp.gatsbyImageData
}
